import { fromJS } from 'immutable';

import MediumRecord from 'records/medium';
import baseReducer from 'redux/baseReducer';
import { createSymbols } from 'utils/helpers';

export const {
    CREATE_MEDIUM,
    CREATE_MEDIUM_FAIL,
    CREATE_MEDIUM_SUCCESS,
    EDIT_MEDIUM,
    RESET_MEDIUM,
    SET_FOCUSED_MEDIUM,
    UPDATE_MEDIUM,
    UPDATE_MEDIUM_FAIL,
    UPDATE_MEDIUM_SUCCESS,
} = createSymbols([
    'CREATE_MEDIUM',
    'CREATE_MEDIUM_FAIL',
    'CREATE_MEDIUM_SUCCESS',
    'EDIT_MEDIUM',
    'RESET_MEDIUM',
    'SET_FOCUSED_MEDIUM',
    'UPDATE_MEDIUM',
    'UPDATE_MEDIUM_FAIL',
    'UPDATE_MEDIUM_SUCCESS',
]);

export const initialState = fromJS({
    data: MediumRecord(),
    errors: {},
    isFetching: false,
});

const handleMediumFail = (state, { error }) => state.set('errors', fromJS(error.response.data));
const editMedium = (state, { field, value }) => state.setIn(['data', field], value);
const resetMedium = () => initialState;
const setFocusedMedium = (state, { medium }) => state.set('data', MediumRecord(medium));
const setMedium = (state, { payload }) => state.set('data', MediumRecord(fromJS(payload.data)));

export default baseReducer(initialState, {
    [CREATE_MEDIUM_FAIL]: handleMediumFail,
    [CREATE_MEDIUM_SUCCESS]: setMedium,
    [EDIT_MEDIUM]: editMedium,
    [RESET_MEDIUM]: resetMedium,
    [SET_FOCUSED_MEDIUM]: setFocusedMedium,
    [UPDATE_MEDIUM_FAIL]: handleMediumFail,
    [UPDATE_MEDIUM_SUCCESS]: setMedium,
});
